import './navbar.css'
import { ThemeContext } from './context'
import { useContext } from 'react'

export default function Navbar() {
    const theme = useContext(ThemeContext)
    const onCheck = function(){
        if(theme.currentTheme === "l"){theme.setTheme({ currentTheme: "d" })}
        else{theme.setTheme({ currentTheme: "l" })}
    }
  return (
    <nav className={`navbar-theme-${theme.currentTheme}`}>
        <div className='all-nav'>
            <div className='logo-section'>
                <img src='https://www.gstatic.com/analytics-suite/header/suite/v2/ic_analytics.svg' alt='logo-img' />
                <h3 className={`logo-analytics-${theme.currentTheme}`}>Analytics</h3>
            </div>
            
            <div className={`nav-account-${theme.currentTheme}`}>
                <span>All Accounts &#062; Default Account for Firebase</span>
                <h1>Root js<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    className="bi bi-caret-down-fill" viewBox="0 0 16 16">
                    <path
                        d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                    </svg></h1>
            </div>

            <div className={`nav-input-${theme.currentTheme}`}>
                <input type="text" placeholder="Try searching Admin"/>
            </div>

        </div>

        <div className='last-container'>

            <div className={`nav-icon-bars-${theme.currentTheme}`}><i className='fas fa-th-large'></i></div>

            <div className={`nav-icon-bars-${theme.currentTheme}`}><i className='fa fa-question-circle'></i></div>
            
            <div className={`nav-icon-bars-${theme.currentTheme}`}><i className='fa fa-ellipsis-v'></i></div>

            <label className="switch">
                <input type="checkbox" onChange={onCheck}/>
                <span className="slider round"></span>
            </label>
        </div>

    </nav>
  )
}
